import IDimensions from "../model/IDimensions";
import {toggleDataLayer} from "../service/toggleDataLayer";


const dataLayerToggleVerification = (dimension: IDimensions) => {
    
    return toggleDataLayer.get(dimension);
}

export default dataLayerToggleVerification